<template>
  <div id="ImportFiscalManage" class="well" style="padding: 0 1em">
    <b-button variant="success" v-on:click="getFiscalInfo()"
      >財政資訊中心調查管理</b-button
    >
    <b-button variant="success" v-on:click="dataMode = 2"
      >財政資訊中心調查結果匯入(查詢非在學生)</b-button
    >
    <b-button variant="success" v-on:click="dataMode = 1"
      >財政資訊中心調查結果匯入(已刪除非在學生)</b-button
    >
    <b-tabs content-class="mt-3">
      <b-tab
        title="財政資訊中心調查管理"
        :active="dataMode == 0"
        :disabled="dataMode != 0"
      >
      <table cellpadding="0" cellspacing="0" class="ncut-table-search">
          <tbody>
            <thead class="ncut-thead-menu">
              <tr>
                <th style="min-width: 6em">學年度：</th>
                <th style="min-width: 5em">
                  <input
                    type="text"
                    onkeyup="this.value=this.value.replace(/[^0-9]/g,'')"
                    onafterpaste="this.value=this.value.replace(/[^0-9]/g,\'\')"
                    onpaste="return false"
                    maxlength="3"
                    v-model="queryInfo.STime"
                    placeholder="如111"
                  />
                </th>
                <th style="min-width: 6em">學期別：</th>
                <th style="min-width: 5em">
                  <input
                    type="text"
                    onkeyup="this.value=this.value.replace(/[^0-9]/g,'')"
                    onafterpaste="this.value=this.value.replace(/[^0-9]/g,\'\')"
                    onpaste="return false"
                    maxlength="2"
                    v-model="queryInfo.ETime"
                    placeholder="如1"
                  />
                </th>

                <th style="min-width: 30em" colspan="3">
                  <b-button variant="success" tabindex="3" @click="query()"
                    ><b-icon icon="search" />&nbsp;{{
                      $t("message.Query_cmd")
                    }}</b-button
                  >&nbsp;

                </th>
              </tr>
            </thead>
          </tbody>
        </table>
        <div
          class="dataTables_scrollBody"
          style="
            font-size: 14px;
            position: relative;
            overflow: auto;
            max-height: 100%;

            border-bottom: 1px solid #111;
            border-top: 1px solid #111;
          "
        >
          <b-table-simple
            class="ncut-table-menu-striped ncut-table-menu"
            fixed
            responsive
            bgcolor="#FFFFFF"
          >
            <b-thead class="ncut-thead-menu">
              <b-tr>
                <b-th style="width: 2em; min-width: 2em">流水號</b-th>
                <b-th style="width: 1em; min-width: 1em">學年度</b-th>
                <b-th style="width: 1em; min-width: 1em">學期別</b-th>
                <b-th style="width: 3em; min-width: 3em">批次別</b-th>
                <b-th style="width: 5em; min-width: 5em">學校名稱</b-th>
                <b-th style="width: 3em; min-width: 3em">學校代號</b-th>
                <b-th style="width: 4em; min-width: 4em">學生身分證字號</b-th>
                <b-th style="width: 2em; min-width: 2em">調查結果</b-th>
                <b-th style="width: 15px; min-width: 15em">管理</b-th>
              </b-tr>
            </b-thead>
            <b-tbody class="ncut-tbody-menu">
              <b-tr
                v-for="(i, index) in filteredDocs"
                :key="i.sn"
                :index="i.sn"
                v-bind:style="{
                  background: selectedRowIndex == index ? headerColor : '',
                }"
                @click="selectedRowIndex = index"
              >
                <b-td style="text-align: left">
                  {{ i.sn }}
                </b-td>
                <b-td style="text-align: left">
                  {{ i.schyy }}
                </b-td>
                <b-td style="text-align: left">
                  {{ i.smt }}
                </b-td>
                <b-td style="text-align: left">
                  {{ i.batchClass }}
                </b-td>
                <b-td style="text-align: left">
                  {{ i.schoolName }}
                </b-td>
                <b-td style="text-align: left">
                  {{ i.schoolCode }}
                </b-td>
                <b-td style="text-align: left">
                  {{ i.idNo }}
                </b-td>
                <b-td style="text-align: left">
                  {{ i.result }}
                </b-td>

                <b-td style="text-align: left">
                  <button
                    href="#"
                    @click="remove(i.sn)"
                    class="btn btn-outline-success"
                    type="button"
                    style="font-size: 14px"
                  >
                    刪除
                  </button>
                </b-td>
              </b-tr>
            </b-tbody>
          </b-table-simple>
          <b-pagination
            v-model="currentPage"
            :total-rows="total"
            :per-page="pageSize"
            v-if="total > pageSize"
          />
        </div>
      </b-tab>
      <b-tab
        title="財政資訊中心調查結果匯入(查詢非在學生)"
        :active="dataMode == 2"
        :disabled="dataMode != 2"
      >
        上傳編碼UTF-8 附檔.csv檔案格式如下(含欄位名稱):<a href="fiscal.csv"
          >下載範例檔</a
        ><br />
        <div>

          <b-form-file
                  class="mb-2"
                  ref="file-input"
                  :no-drop="true"
                  :no-traverse="true"
                  name="file"
                  v-model="file"
                  @input="fileChange(0)"
                  placeholder="上傳csv檔案"
                  accept=".csv"
                  enctype="multipart/form-data"
                ></b-form-file>

                <button
                  href="#"
                  @click.prevent="importCodeFiscal2()"
                  class="btn btn-outline-success"
                  type="button"
                  style="font-size: 14px"
                >
                  送出
                </button>
        </div>
        <table v-if="null != inputData2" class="table" style="width: auto; align: left">
          <tbody>
            <tr>
              <td>學號</td>
              <td>身分證字號</td>
              <td>姓名</td>
              <td>電子郵件</td>
              <td>連絡電話</td>
              <td>學籍狀態</td>
              <td>學籍最後異動時間</td>

            </tr>


              <tr
                v-for="(item, index) in inputData2"
                :key="item.idNo"
                :index="item.idNo"
                v-bind:style="{
                  background: selectedRowIndex == index ? headerColor : '',
                }"
                @click="selectedRowIndex = index"
              >
                <td style="text-align: left">{{ item.sid }}</td>
                <td style="text-align: left">{{ item.idNo }}</td>
                <td style="text-align: left">{{ item.name }}</td>
                <td style="text-align: left">{{ item.eMail }}</td>
                <td style="text-align: left">{{ item.contactPhone }}</td>
                <td style="text-align: left">{{ item.reason }}</td>
                <td style="text-align: left">{{ getToday(item.updateTime) }}</td>

              </tr>

          </tbody>
        </table>
      </b-tab>
      <b-tab
        title="財政資訊中心調查結果匯入(已刪除非在學生)"
        :active="dataMode == 1"
        :disabled="dataMode != 1"
      >
        上傳編碼UTF-8 附檔.csv檔案格式如下(含欄位名稱):<a href="fiscal.csv"
          >下載範例檔</a
        ><br />
        <table class="table" style="width: auto; align: left">
          <tbody>
            <tr>
              <td>流水號</td>
              <td>學年度</td>
              <td>學期別</td>
              <td>批次別</td>
              <td>學校名稱</td>
              <td>學校代號</td>
              <td>學生身分證字號</td>
              <td>調查結果</td>
            </tr>

            <tr>
              <td>1</td>
              <td>111</td>
              <td>1</td>
              <td>第1批次</td>
              <td>國立勤益科技大學</td>
              <td>060043</td>
              <td>L123456789</td>
              <td>合格</td>
            </tr>
            <tr>
              <td style="text-align: left; padding: 1em" colspan="6">
                <b-form-file
                  class="mb-2"
                  ref="file-input"
                  :no-drop="true"
                  :no-traverse="true"
                  name="file"
                  v-model="file"
                  @input="fileChange(0)"
                  placeholder="上傳csv檔案"
                  accept=".csv"
                  enctype="multipart/form-data"
                ></b-form-file>

                <button
                  href="#"
                  @click.prevent="importCodeFiscal()"
                  class="btn btn-outline-success"
                  type="button"
                  style="font-size: 14px"
                >
                  送出
                </button>
              </td>
            </tr>
          </tbody>
        </table>
      </b-tab>
    </b-tabs>
    <b-modal ref="q-modal" hide-footer title="請注意">
      <div class="d-block text-center">
        <h3>是否確認刪除此筆資料?</h3>
      </div>
      <b-button class="mt-3" variant="outline-danger" block @click="cancalRM"
        >取消刪除</b-button
      >
      <b-button class="mt-2" variant="outline-info" block @click="confirmRM"
        >刪除確認</b-button
      >
    </b-modal>
  </div>
</template>


<script>
import * as tools from "../tool";

export default {
  name: "ImportFiscalManage",
  data() {
    return {
      sn: 0,
      total: 0,
      inputData: null,
      inputData2: null,
      selectedRowIndex: 0,
      currentPage: 1,
      pageSize: 10,
      dataMode: 0,
      selectedFile: null,
      mode: 0,
      file: [],
      queryInfo: {
        STime: null,
        ETime: null,
        dataMode: 0,
      },
    };
  },
  computed: {
    filteredDocs: function () {
      let data = [];
      if (this.inputData != null) {
        data = this.inputData.slice(
          (this.currentPage - 1) * this.pageSize,
          this.currentPage * this.pageSize
        );
      }
      return data;
    },

    headerColor() {
      return "#f7e8aa";
    },
  },
  methods: {
    getToday(updateTime) {
  var dd = new Date(updateTime);
  var today = dd.getDate().toString().padStart(2, "0"); //內建getDate 取到目前年月日
  var mm = (dd.getMonth() + 1).toString().padStart(2, "0"); //January is 0!
  var yyyy = dd.getFullYear();
  var hours = dd.getHours().toString().padStart(2, "0");
var minutes = dd.getMinutes().toString().padStart(2, "0");
var seconds = dd.getSeconds().toString().padStart(2, "0");

  return tools.stringFormat("{0}-{1}-{2} {3}:{4}:{5}", yyyy, mm, today, hours, minutes, seconds);
},
    fileChange(index) {
      this.formData = new FormData();

      if (index == 0) {
        this.formData.append("header", this.file);
      }
      var vm = this;
      this.$http
        .post("./WebApi/Common/UploadV3", vm.formData, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
          onUploadProgress: function (progressEvent) {
            console.log(
              "Upload progress: " +
                Math.round((progressEvent.loaded / progressEvent.total) * 100) +
                "%"
            );
          },
        })
        .then(function (response) {
          console.log("ok");
        })
        .catch(function (error) {
          console.log(error);
          console.log(error.response);
        });
    },
    remove(sn) {
      this.sn = sn;
      this.$refs["q-modal"].show();
    },
    cancalRM() {
      this.$refs["q-modal"].hide();
    },

    confirmRM() {
      //刪除專班Code資料
      this.$refs["q-modal"].hide();
      var vm = this;
      this.$http
        .get(
          "./WebApi/EconomicDisadvantage/RemoveFiscalCode/".concat(vm.sn)
        )
        .then((response) => {
          if (response.data) {
            tools.showAlert(vm, "success", "恭喜您,刪除成功");
            vm.getFiscalInfo();
          } else {
            tools.showAlert(vm, "danger", "對不起,刪除失敗");
          }
        })
        .catch(function (error) {
          tools.showAlert(vm, "danger", "網路連線失敗" + error);
        });
    },
    importCodeFiscal() {
      var vm = this;
      if (vm.isEmpty(vm.file.name)) {
        alert("請上傳csv檔案");
        return;
      }
      this.$http
        .get("./WebApi/EconomicDisadvantage/ImportCodeFiscal")
        .then((response) => {
          if (response.data != "") {
            console.log(response);
            //tools.showAlert(vm, "success", "匯入檔案成功" );
            alert("匯入檔案成功");
            vm.getFiscalInfo();
          } else {
            alert("匯入檔案失敗");
          }
        })
        .catch((error) => {
          // alert("匯入檔案失敗");
          console.log(error);
          tools.showAlert(vm, "danger", "匯入檔案失敗");
        });
    },
    importCodeFiscal2() {
      var vm = this;
      if (vm.isEmpty(vm.file.name)) {
        alert("請上傳csv檔案");
        return;
      }
      this.$http
        .get("./WebApi/EconomicDisadvantage/ImportCodeFiscal2")
        .then((response) => {
          if (response.data != "") {
            console.log(response);
            //tools.showAlert(vm, "success", "匯入檔案成功" );
            alert("匯入檔案成功");
            vm.inputData2 = response.data;
            vm.total = vm.inputData2.length;
            vm.currentPage = 1;

          } else {
            alert("匯入檔案失敗");
          }
        })
        .catch((error) => {
          // alert("匯入檔案失敗");
          console.log(error);
          tools.showAlert(vm, "danger", "匯入檔案失敗");
        });
    },


    close() {
      this.$emit("hideModal");
    },
    isEmpty(data) {
      return data != null && data != undefined && data.length > 0
        ? false
        : true;
    },

    getFiscalInfo() {
      this.dataMode = 0;
      let vm = this;
      vm.selected2 = vm.IsComplete;

      this.$http
        .get("./WebApi/EconomicDisadvantage/GetFiscalInfo/")
        .then((response) => {
          if (!tools.isNull(response.data)) {
            vm.inputData = response.data;
            vm.total = vm.inputData.length;
            vm.currentPage = 1;
          }
        })
        .catch(function (error) {
          alert("網路連線失敗" + error);
          // tools.showAlert(vm.inputData, "danger", "網路連線失敗" + error);
        });
    },

    checkSaveData() {
      let msg = "";
      if (this.queryInfo.STime == null) msg = "請輸入申請學年度";
      if (this.queryInfo.ETime == null) msg = "請輸入學期別";

      return msg;
    },
    query() {
      var msg = this.checkSaveData();
      if (0 == msg.length) {
        let vm = this;
        vm.inputData = null;
        vm.total = 0;
        vm.queryInfo.dataMode = vm.dataMode;

        this.$http
          .put("./WebApi/EconomicDisadvantage/GetFiscalList", vm.queryInfo)
          .then((response) => {
            if (response.data != null) {
              vm.inputData = response.data;
              vm.total = vm.inputData.length;
            }
          })
          .catch(function (error) {
            tools.showAlert(vm, "danger", "對不起,網路連線失敗" + error);
          });
      } else {
        tools.showAlert(this, "danger", "對不起,請輸入" + msg);
      }
    },
  },
  created() {
    console.log("======created ImportCodeManageView =====");
    this.getFiscalInfo();
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
